import { render, staticRenderFns } from "./payDiaStep2.vue?vue&type=template&id=06663239&scoped=true&"
import script from "./payDiaStep2.vue?vue&type=script&lang=js&"
export * from "./payDiaStep2.vue?vue&type=script&lang=js&"
import style0 from "./payDiaStep2.vue?vue&type=style&index=0&id=06663239&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06663239",
  null
  
)

export default component.exports